<!-- 驾驶舱首页 -->
<template>
  <div class="container">
    <!-- 顶部信息 -->
    <div class="topMessage">
      <!-- 项目中心 -->
      <div class="project_center box_common">
        <div class="title">
          <span>项目中心</span>
          <span @click="showCounselor" style="cursor: pointer"> 顾问 </span>
          <span @click="showBusinessManager" style="cursor: pointer">商务经理</span>
        </div>
        <div class="context">
          <div class="item">
            <div class="underway item_common">
              <div class="icon_box">
                <i class="el-icon-right"></i>
              </div>
              <div class="txt">
                <span>进行中</span>
              </div>
              <div class="quantity">
                <span>({{ projectCentreObj.underWayNumber }})</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="succeed item_common">
              <div class="icon_box">
                <i class="el-icon-top-right"></i>
              </div>
              <div class="txt">
                <span>成功项目</span>
              </div>
              <div class="quantity">
                <span>({{ projectCentreObj.successNumber }})</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="frozen_account item_common">
              <div class="icon_box">
                <i class="el-icon-close"></i>
              </div>
              <div class="txt">
                <span>冻结项目</span>
              </div>
              <div class="quantity">
                <span>({{ projectCentreObj.freezeNumber }})</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="end item_common">
              <div class="icon_box">
                <i class="el-icon-close" style="font-size: 14px"></i>
              </div>
              <div class="txt">
                <span>结束项目</span>
              </div>
              <div class="quantity">
                <span>({{ projectCentreObj.finishNumber }})</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 业务中心 -->
      <div class="business_center box_common">
        <div class="title">
          <span>业务中心</span>
        </div>
        <div class="context">
          <div class="item">
            <div class="underway item_common">
              <div class="icon_box" style="">
                <i class="el-icon-right"></i>
              </div>
              <div class="txt">
                <span>投资事件</span>
              </div>
              <div class="quantity">
                <span>({{ businessCentreObj.underWayNumber }})</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="succeed item_common">
              <div class="icon_box">
                <i class="el-icon-top-right"></i>
              </div>
              <div class="txt">
                <span>线索中心</span>
              </div>
              <div class="quantity">
                <span>({{ businessCentreObj.successNumber }})</span>
              </div>
            </div>
          </div>

          <div class="item">
            <div class="frozen_account item_common">
              <div class="icon_box">
                <i class="el-icon-close"></i>
              </div>
              <div class="txt">
                <span>客户中心</span>
              </div>
              <div class="quantity">
                <span>({{ businessCentreObj.freezeNumber }})</span>
              </div>
            </div>
          </div>

          <div class="item">
            <div class="end item_common">
              <div class="icon_box">
                <i class="el-icon-close" style="font-size: 14px"></i>
              </div>
              <div class="txt">
                <span>已签约</span>
              </div>
              <div class="quantity">
                <span>({{ businessCentreObj.finishNumber }})</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 消息通知 -->
      <div class="message_inform box_common">
        <div class="title">
          <span>消息通知</span>
          <div class="icon_box">
            <div class="item" v-for="(item, index) in 3" :key="index"></div>
          </div>
        </div>
        <div class="context">
          <div class="message_item" v-for="(item, index) in 3" :key="index">
            <div class="time txt">
              <span>2022-08-25</span>
            </div>
            <div class="message txt">
              <span>Andrew您好，客户中心有新增，需要您去分配新的客户经理</span>
            </div>
            <div class="examine">
              <span>未读</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 内部管理 -->
    <div class="card">
      <div class="top">
        <div class="title">
          <span>内部管理</span>
        </div>
        <div class="time">
          <el-date-picker v-model="queryInnerManagement.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <div class="table">
        <el-table :data="innerManagementTableData" tooltip-effect="dark" style="width: 100%">
          <el-table-column label="姓名/级别" align="center">
            <template slot-scope="scope">
              <span class="color2"> {{ scope.row.nameEnglish }}|{{ scope.row.rank }} </span>
            </template>
          </el-table-column>
          <el-table-column label="客户量" align="center" prop="customerQuantity" sortable>
          </el-table-column>
          <el-table-column label="项目量" align="center" prop="projectQuantity" sortable>
          </el-table-column>
          <el-table-column label="" align="center">
            <template slot="toper">
              当周指标
              <el-tooltip class="item" effect="dark" content="当周指标详细内容" placement="bottom">
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span class="color3 color4">
                {{ scope.row.thisWeekIndex }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="上周指标" align="center" prop="lastWeekIndex">
            <template slot-scope="scope">
              <span class="color3 color4">
                {{ scope.row.lastWeekIndex }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="面试人数" align="center" prop="interviewNumber" sortable>
          </el-table-column>
          <el-table-column label="offer人数" align="center" prop="offerPeopleNumber" sortable>
          </el-table-column>
          <el-table-column label="入职人数" align="center" prop="entryNumber" sortable>
          </el-table-column>
          <el-table-column label="最近推荐日期" align="center" prop="lastRecommendedDate" sortable>
          </el-table-column>
          <el-table-column label="" align="center">
            <template slot="toper">
              当季度业绩
              <el-tooltip
                class="item"
                effect="dark"
                content="当季度业绩"
                placement="bottom"
                sortable
              >
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span class="color3 color4">
                {{ scope.row.whenQuarterlyResults }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="上季度业绩" align="center" sortable>
            <template slot-scope="scope">
              <span class="color3 color4">
                {{ scope.row.lastQuarterlyResults }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="打卡异常次数" align="center">
            <template slot-scope="scope">
              <span class="color3 color4">
                {{ scope.row.clockInAbnormalNumber }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <div class="pagination">
        <el-pagination
          :current-page="queryInnerManagement.baseParam.pageNum"
          :page-sizes="[10, 30, 50]"
          :page-size="queryInnerManagement.baseParam.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="innerManagementTotal"
          @size-change="handleSizeChange01"
          @current-change="handleCurrentChange01"
        />
      </div>
    </div>
    <!-- 项目汇总 -->
    <div class="card">
      <div class="top">
        <div class="title">
          <span>项目汇总</span>
        </div>
        <div class="time">
          <el-date-picker v-model="queryProjectSummary.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <div class="search_list">
        <el-form label-width="100px">
          <el-form-item label="项目状态：">
            <el-select v-model="queryProjectSummary.projectSchedule" placeholder="请选择">
              <el-option
                v-for="(item, index) in projectScheduleOptions"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称：">
            <el-select v-model="queryInnerManagement.corporateName" placeholder="请选择">
              <el-option
                v-for="(item, index) in corporateNameOptions"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优先级：">
            <el-select v-model="queryInnerManagement.priority" placeholder="请选择">
              <el-option
                v-for="(item, index) in priorityOptions"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table :data="projectSummaryTableData" tooltip-effect="dark" style="width: 100%">
          <el-table-column label="项目状态" align="center" prop="projectSchedule" sortable>
            <template slot-scope="scope">{{ scope.row.projectSchedule }}</template>
          </el-table-column>
          <el-table-column label="公司名称" align="center" prop="corporateName" sortable>
          </el-table-column>
          <el-table-column label="岗位名称" align="center" prop="post"> </el-table-column>
          <el-table-column label="项目经理" align="center" prop="projectManager"> </el-table-column>
          <el-table-column label="优先级" align="center" sortable> </el-table-column>
          <el-table-column label="最近推荐日期" align="center" prop="lastRecommendedDate" sortable>
          </el-table-column>
          <el-table-column label="推荐人数" align="center" prop="recommendedNumber" sortable>
          </el-table-column>
          <el-table-column label="面试人数" align="center" prop="interviewNumber" sortable>
          </el-table-column>
          <el-table-column label="薪酬范围(万)" align="center" prop="salaryRange" sortable>
          </el-table-column>
          <el-table-column label="JD" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="showJD(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="寻访方案" align="center">
            <template slot-scope="scope">
              <el-button class="color1" size="mini" plain @click="editSearchScheme(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <div class="pagination">
        <el-pagination
          :current-page="queryProjectSummary.baseParam.pageNum"
          :page-sizes="[10, 30, 50]"
          :page-size="queryProjectSummary.baseParam.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="projectSummaryTotal"
          @size-change="handleSizeChange02"
          @current-change="handleCurrentChange02"
        />
      </div>
    </div>
    <!-- 业务中心 -->
    <div class="card">
      <div class="top">
        <div class="title">
          <span>业务中心</span>
        </div>
        <div class="time">
          <el-date-picker v-model="queryBusinessCenter.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <div class="search_list">
        <el-form label-width="80px">
          <el-form-item label="进度：">
            <el-select v-model="queryProjectSummary.projectSchedule" placeholder="请选择">
              <el-option
                v-for="(item, index) in projectScheduleOptions"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优先级：">
            <el-select v-model="queryInnerManagement.priority" placeholder="请选择">
              <el-option
                v-for="(item, index) in priorityOptions"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table :data="businessCenterTableData" tooltip-effect="dark" style="width: 100%">
          <el-table-column label="进度" align="center" sortable>
            <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column>
          <el-table-column label="线索企业" align="center">
            <template slot-scope="scope">
              <img src="" alt="" />
              {{ scope.row.enterpriseName }}
            </template>
          </el-table-column>
          <el-table-column label="所在城市" align="center">
            <template slot-scope="scope">
              <span>
                {{ scope.row.province + scope.row.city }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="优先级" align="center" sortable>
            <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column>
          <el-table-column label="商务经理" align="center" prop="englishName"> </el-table-column>
          <el-table-column label="创建日期" align="center" sortable>
            <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column>
          <el-table-column label="最近更新日期" align="center" sortable>
            <template slot-scope="scope">{{ scope.row.date }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <div class="pagination">
        <el-pagination
          :current-page="queryBusinessCenter.baseParam.pageNum"
          :page-sizes="[10, 30, 50]"
          :page-size="queryBusinessCenter.baseParam.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="businessCenterTotal"
          @size-change="handleSizeChange03"
          @current-change="handleCurrentChange03"
        />
      </div>
    </div>
    <!-- 消息通知弹窗 -->
    <el-dialog title="提示" :visible.sync="messageDialogVisible" width="30%">
      <span>消息通知弹窗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="messageDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="messageDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 推荐人数弹窗 -->
    <el-dialog title="提示" :visible.sync="interviewNumberDialogVisible" width="30%">
      <span>推荐人数弹窗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="interviewNumberDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="interviewNumberDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 面试人数弹窗 -->
    <el-dialog title="提示" :visible.sync="recommendedNumberDialogVisible" width="30%">
      <span>面试人数弹窗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recommendedNumberDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="recommendedNumberDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  projectCentre,
  businessCentre,
  innerManagement,
  saveInnerManagement,
  projectSummary,
  businessCenter
} from '@/api/flightDeck.js'

const defaultQueryInnerManagement = Object.freeze({
  baseParam: {
    pageNum: 1,
    pageSize: 10
  },
  date: '',
  order: '',
  orderType: 0
})
const defaultQueryProjectSummary = Object.freeze({
  baseParam: {
    pageNum: 1,
    pageSize: 10
  },
  date: '', //时间
  order: '', //排序:desc正序；asc反序
  orderType: 0, //排序类型0->优先级；1->推荐人数；2->面试人数；3->薪酬范围
  priority: '', //优先级别
  projectSchedule: '' //项目进度
  //缺少字段 公司名字
})
const defaultQueryBusinessCenter = Object.freeze({
  baseParam: {
    pageNum: 1,
    pageSize: 10
  },
  date: '', //时间
  order: '', //排序:desc正序；asc反序
  orderType: 0, ////排序类型0->优先级；1->创建时间；2->更新时间
  priority: '', //优先级别
  projectSchedule: '' //项目进度
})

export default {
  components: {},
  data() {
    return {
      // 头部项目中心数据
      projectCentreObj: {
        finishNumber: '', //结束项目
        freezeNumber: '', //冻结项目
        successNumber: '', //成功项目
        underWayNumber: '' //进行中
      },
      // 头部业务中心数据
      businessCentreObj: {
        finishNumber: '', //已签约
        freezeNumber: '', //客户中心
        successNumber: '', //线索中心
        underWayNumber: '' //投资事件
      },
      //内部管理 请求数据
      queryInnerManagement: { ...defaultQueryInnerManagement },
      innerManagementTableData: [], // 内部管理 表格数据
      innerManagementTotal: 0, //内部管理 总条数
      //项目汇总 请求数据
      queryProjectSummary: { ...defaultQueryProjectSummary },
      projectSummaryTableData: [], // 项目汇总 表格数据
      projectSummaryTotal: 0, //项目汇总 总条数
      //业务中心 请求数据
      queryBusinessCenter: { ...defaultQueryBusinessCenter },
      businessCenterTableData: [], // 业务中心 表格数据
      businessCenterTotal: 0, //业务中心 总条数
      //项目状态列表
      projectScheduleOptions: [
        {
          label: '立项'
        },
        {
          label: '人才mapping'
        },
        {
          label: '人才推荐'
        },
        {
          label: '面试邀约'
        },
        {
          label: 'offer谈判'
        },
        {
          label: 'offer接收'
        },
        {
          label: '入职'
        },
        {
          label: '保证期结束'
        }
      ],
      //公司名称列表
      corporateNameOptions: ['1', '2', '3', '4'],
      //优先级列表
      priorityOptions: [
        {
          label: '最高'
        },
        {
          label: '高'
        },
        {
          label: '较低'
        },
        {
          label: '低'
        }
      ],
      messageDialogVisible: false, //消息通知弹窗
      interviewNumberDialogVisible: false, //面试人数弹窗
      recommendedNumberDialogVisible: false //推荐人数弹窗
    }
  },
  computed: {},
  watch: {},
  methods: {
    //前往顾问视图
    showCounselor() {
      this.$router.push({
        path: '/flightDeck/counselorPage'
      })
    },
    //前往商务经理视图
    showBusinessManager() {
      this.$router.push({
        path: '/flightDeck/businessManager'
      })
    },
    // 头部项目中心数据
    async getProjectCentre() {
      const { data: res } = await projectCentre()
      if (res.resultCode == 200) {
        this.projectCentreObj = res.data
      }
    },
    // 头部业务中心数据
    async getBusinessCentre() {
      const { data: res } = await businessCentre()
      if (res.resultCode == 200) {
        this.businessCentreObj = res.data
      }
    },
    //获取内部管理表格数据
    async getInnerManagementTableData() {
      const { data: res } = await innerManagement(this.queryInnerManagement)
      if (res.resultCode == 200) {
        this.innerManagementTableData = res.data.list
      }
    },
    //获取项目汇总表格数据
    async getProjectSummaryTableData() {
      const { data: res } = await innerManagement(this.queryProjectSummary)
      if (res.resultCode == 200) {
        this.projectSummaryTableData = res.data.list
      }
    },
    //获取业务中心表格数据
    async getBusinessCenterTableData() {
      const { data: res } = await businessCenter(this.queryBusinessCenter)
      if (res.resultCode == 200) {
        this.businessCenterTableData = res.data.list
      }
    },

    //查看JD
    showJD(row) {},
    //编辑寻访方案
    editSearchScheme(row) {},
    //内部管理  每页显示条数
    handleSizeChange01(val) {
      this.queryInnerManagement.baseParam.pageSize = val
      this.getInnerManagementTableData()
    },
    //内部管理  页码值
    handleCurrentChange01(val) {
      this.queryInnerManagement.baseParam.pageNum = val
      this.getInnerManagementTableData()
    },
    //项目汇总  每页显示条数
    handleSizeChange02(val) {
      this.queryProjectSummary.baseParam.pageSize = val
      this.getProjectSummaryTableData()
    },
    //项目汇总  页码值
    handleCurrentChange02(val) {
      this.queryProjectSummary.baseParam.pageNum = val
      this.getProjectSummaryTableData()
    },
    //业务中心  每页显示条数
    handleSizeChange03(val) {
      this.queryBusinessCenter.baseParam.pageSize = val
      this.getBusinessCenterTableData()
    },
    //业务中心  页码值
    handleCurrentChange03(val) {
      this.queryBusinessCenter.baseParam.pageNum = val
      this.getBusinessCenterTableData()
    }
  },

  created() {
    this.getProjectCentre()
    this.getBusinessCentre()
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.pagination {
  text-align: center;
  margin: 20px 0;
}
.container {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.topMessage {
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  .box_common {
    background-color: #ffffff;
    padding-left: 24px;
    padding-top: 24px;
    box-sizing: border-box;
    border-radius: 8px;
  }
  .title {
    min-width: 80px;
    font-size: 20px;
    font-weight: 500;
    color: #06152b;
    margin-bottom: 40px;
  }
  .context {
    display: flex;
    flex-wrap: wrap;
    .item {
      min-width: 180px;
      padding-right: 10px;
      padding-bottom: 20px;
      box-sizing: border-box;
    }
    .item_common {
      display: flex;
      align-items: center;
      padding: 0 10px;
      .icon_box {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 2px;
        i {
          width: 20px;
          height: 20px;
        }
      }
      .txt {
        min-width: 64px;
        margin-right: 10px;
      }
      .quantity {
        min-width: 60px;
      }
    }
  }
  .project_center,
  .business_center {
    width: 424px;
    .item {
      width: 50%;
    }
  }
  .business_center {
    margin: 0 15px;
  }
  .message_inform {
    flex: 1;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px 0 0;
      .icon {
        width: 18px;
        height: 4px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        .item {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #6b738d;
        }
      }
    }
    .context {
      .message_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 95%;
        height: 40px;
        background-color: #f6f7f7;
        border-radius: 2px;
        margin-bottom: 6px;
        padding-right: 10px;
        .txt {
          min-width: 100px;
          color: #06152b;
          font-size: 16px;
          span {
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            white-space: nowrap;
            height: 24px;
            display: block;
          }
        }
        .message {
          width: 75%;
          overflow: hidden;
          margin-left: 15px;
        }
        .examine {
          width: 32px;
          height: 24px;
          background-color: #ff7676;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          font-size: 10px;
        }
      }
    }
  }
}
.card {
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-bottom: 16px;
  border-radius: 8px;
  background-color: #fff;
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 100px 0 40px;
  min-height: 100px;
  box-sizing: border-box;
  .title {
    font-size: 24px;
    font-weight: 600;
    color: #06152b;
  }
  .time {
    color: #06152b;
  }
}
.table {
  width: 100%;
  max-height: 50vh;
  overflow: scroll;
  padding: 0 40px;
  box-sizing: border-box;
}

.search_list {
  width: 90%;
  padding: 0 60px 0 20px;
  ::v-deep .el-form {
    display: flex;
    width: 100%;
  }
  ::v-deep .el-form-item {
    margin-right: 20px;
  }
}
.color1 {
  color: #17757a;
}
.color2 {
  color: #4d70fa;
}
.color3 {
  color: #1fc411;
}
.color4 {
  color: #ef3232;
}
.underway {
  color: #ffb536;
}
.succeed {
  color: #1ad598;
}
</style>
